export class ErrorConstants {
  static dataNotAvailableStr = 'Data is not available';
  static PLACEHOLDERS = {
    comments_placeholder: 'Please enter you inputs',
    subjects_placeholder: 'Select your subject',
    reasons_placeholder: 'Select a reason',
    valid_inputs: 'Please enter valid comments!',
    search_inputs: 'Search',
  };
  static ERROR_MESSAGES = {
    USERNAME: {
      REQUIRED: 'Username is required.',
      INVALID: 'Username is invalid.',
      EMAIL: 'Invalid email address',
    },
    PASSWORD: {
      REQUIRED: 'Password is required',
      INVALID: 'Password is not strong.',
      NEW_REQ: 'New password is required',
      CONFIRM_REQ: 'Confirm password is required.',
      MISMATCH: 'Passwords do not match.',
    },
    GLOBAL: {
      LOGIN_FAILED: 'Username or Password is incorrect',
      EMPTY_FIELDS: 'Please check all input fields.',
      INVALID_CREDS: 'Click on Forgot Password link to reset password.',
      TURING_SERVER:
        'Oops! There seems to be a technical issue. Please retry in a few minutes',
      SF_ERROR:
        'Oops! There seems to be a technical issue. Please retry in a few minutes',
      UN_AUTHORIZED_USER:
        'Oops! You are not an authorized user. Please contact Admin',
    },
    PREFERENCE: {
      UPDATE_FAILED: 'Preference update has failed',
      UPDATE_SUCCESSFUL: 'Preference update is successful',
    },
    DATA: {
      DEVICE_DATA: ErrorConstants.dataNotAvailableStr,
    },
    NETWORK: {
      NO_NETWORK:
        'Internet unavailable on the device. Please connect to the internet and try again',
    },
    PROFILE: {
      PROFILE_DATA: ErrorConstants.dataNotAvailableStr,
    },
    BILLING: {
      MONTHLY_BILLING_DATA: ErrorConstants.dataNotAvailableStr,
    },
    FEEDS: {
      NEWS_FEEDS: ErrorConstants.dataNotAvailableStr,
    },
    USAGE: {
      ENERGY_USAGE: ErrorConstants.dataNotAvailableStr,
    },
    EMAIL_SERVICE: {
      SUCCESS: 'Email has sent successfully',
      FAIL: 'Email sending has been failed',
    },
    UPLOAD_IMAGE: {
      UPLOADING_ERROR: 'Error while selecting image.',
      MAX_UPLOAD_ERROR: 'Maximum number of files to be uploaded',
      FILE_SIZE_ERROR: 'Total file size must be no larger than 6MB',
    },
    TOKEN: {
      TOKEN_EXP: 'Session has expired. Please reopen the app',
    },
  };
  constructor() {}
}
